import { Component, EventEmitter, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalLoaderFacade as SlimLoadingBarService } from '../../../sharedServices/globalLoaderFacade/global-loader-facade.service';
import { handleErrors } from '../../../common/error';
import { TranslateService } from '@ngx-translate/core';
import { Donation, ModalAction } from '../../../models';
import { getNumberFromInput } from 'app/dashboard/servicesComponets/surveys/survey-helpers';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DonationManagementService } from '../../donationHelper/donation-management.service';
import { EmailValidator } from '../../../validators/emailValidator';
import { LeadingTrailingWhiteSpaceValidator } from '../../../validators/leadingTrailingWhiteSpaceValidator';
import { AppSettings } from 'app/common/config';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'donation-modal',
  templateUrl: './donation-modal.component.html',
  styleUrls: ['../../common-search.css', './donation-modal.component.css'],
  providers: [DonationManagementService],
})
export class DonationModalComponent implements OnInit {
  public loading = true;
  isSubmitting = false;
  donateForm: UntypedFormGroup;
  tippingSr = false;
  @Input() orgName: any;
  @Input() orgId: any;
  @Input() donateUrl: any;
  @Input() donateModalActions: any;
  @Input() tippingModalActions: any;

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private translateSvc: TranslateService,
    private globalLoader: SlimLoadingBarService,
    private donationManagementService: DonationManagementService
  ) {}

  ngOnInit() {
    this.globalLoader.start();
    this.loading = true;

    this.donateForm = new UntypedFormGroup({
      donatorEmail: new UntypedFormControl('', [
        Validators.maxLength(64),
        EmailValidator.mailFormat,
        LeadingTrailingWhiteSpaceValidator.leadingTrailingWhiteSpaceFormat,
      ]),
      donationAmount: new UntypedFormControl('', Validators.pattern(AppSettings.US_CURRENCY_REGEX_PATTERN)),
      tippingSr: new UntypedFormControl('', Validators.required),
    });
  }

  onSubmit(orgId: number, donateUrl: string) {
    if (this.isSubmitting) {
      return;
    }

    this.globalLoader.start();
    this.loading = true;
    this.isSubmitting = true;

    const newRecord: Donation = this.donateForm.value;
    const organizationName = this.orgName;

    newRecord.donatedOrgId = orgId;
    newRecord.donationAmount = getNumberFromInput(this.donateForm.controls['donationAmount'].value);

    this.donationManagementService.addNewDondationRecord(newRecord).subscribe(
      () => {
        this.isSubmitting = false;

        this.toastr.success(
          this.translateSvc.instant('Donation-SUCCESS_CREATE_MESSAGE', { organizationName }),
          this.translateSvc.instant('Donation-COMMON_TITLE'),
          { timeOut: 5000 }
        );

        this.globalLoader.complete();
        this.loading = false;
        this.donateModalActions.emit({ action: 'modal', params: ['close'] });

        if (this.tippingSr) {
          this.tippingModalActions.emit({ action: 'modal', params: ['open'] });
        }

        this.donateForm.reset();
      },
      (error) => {
        handleErrors(error, this.translateSvc, this.toastr, 'Donation-COMMON_TITLE');
        this.isSubmitting = false;
        this.globalLoader.complete();
        this.loading = false;
      }
    );
  }
}
